import { memo } from 'react'
import { translate } from 'utils/translations'
import { getCountIndicatorColorName } from './utils'
import { IProps } from './types'
import * as Styled from './styled'
import { T } from 'consts/translationKeys'

const CharacterCountIndicator: React.FC<IProps> = props => {
  const {
    currentTextLength,
    maxCount,
    textWarningState = null,
    isDisabled = false,
    hasText = false,
    textType = 'h7',
    className
  } = props

  const indicatorColor = getCountIndicatorColorName(textWarningState)

  return (
    <Styled.CharacterCountIndicatorWrapper
      className={className}
      color={indicatorColor}
      type={textType}
      $isDisabled={isDisabled}
    >
      <Styled.CountLimit>{`${currentTextLength} / ${maxCount}`}</Styled.CountLimit>
      {hasText && (
        <Styled.TextCountLimit>
          {translate(T.CHARACTERS_ADVISED_LABEL)}
        </Styled.TextCountLimit>
      )}
    </Styled.CharacterCountIndicatorWrapper>
  )
}

export default memo(CharacterCountIndicator)
